import { Component, input, Input, OnInit } from '@angular/core';

import {
  EnableClassTelemetry,
  EnableComponentTelemetry,
  injectComponentTelemetryService,
} from 'app/services/otel.service';

@EnableClassTelemetry()
@Component({
  selector: 'app-middle-ellipsize-fragment',
  template: `
    <div
      [matTooltip]="tooltip"
      class="lex-ellipsize__wrapper"
      [ngClass]="'lex-ellipsize__wrapper--align-' + align"
    >
      @if (useHtml()) {
        <div class="lex-ellipsize--left" [innerHTML]="leftPart"></div>
      } @else {
        <div class="lex-ellipsize--left">{{ leftPart }}</div>
      }
      <div class="lex-ellipsize--right">
        @if (useHtml()) {
          <bdi [innerHTML]="rightPart&nbsp;"></bdi>
        } @else {
          <bdi>{{ rightPart }}&nbsp;</bdi>
        }
      </div>
      <span [ngClass]="{ 'left-mat-badge': text.length < 18 }" [matBadge]="badge"></span>
    </div>
  `,
  styles: [
    `
      :host {
        overflow: hidden;
        display: block;
      }

      :host:hover .mat-badge {
        opacity: 1;
      }

      .lex-ellipsize__wrapper {
        overflow: hidden;
        display: flex;
      }

      .lex-ellipsize__wrapper--align-start {
        justify-content: start;
      }

      .lex-ellipsize__wrapper--align-center {
        justify-content: center;
      }

      .lex-ellipsize__wrapper--align-end {
        justify-content: end;
      }

      .lex-ellipsize--left {
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: pre;
      }

      .lex-ellipsize--right {
        text-overflow: clip;
        overflow: hidden;
        white-space: pre;
        direction: rtl;
      }

      .left-mat-badge {
        left: 8px;
      }

      .mat-badge {
        top: 13px;
        right: 13px;
        opacity: 0.75;
      }
    `,
  ],
  standalone: false,
})
export class MiddleEllipsizeFragmentComponent implements OnInit {
  @EnableComponentTelemetry() otelService = injectComponentTelemetryService();
  @Input() text: string;
  @Input() tooltip?: string;
  @Input() badge?: string;
  @Input() align? = 'start';
  @Input() hideTooltip?: boolean;
  readonly useHtml = input<boolean>(false);

  leftPart: string;
  rightPart: string;

  constructor() {}

  ngOnInit() {
    if (this.text) {
      this.leftPart = this.text.substring(0, (this.text.length - 2) / 2);
      this.rightPart = this.text.substring((this.text.length - 2) / 2);

      if (!this.tooltip) {
        this.tooltip = this.text;
      }
      if (this.hideTooltip) {
        this.tooltip = null;
      }
    }
  }
}
